import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hr-holidays',
  templateUrl: './hr-holidays.component.html',
  styleUrls: ['./hr-holidays.component.scss']
})
export class HrHolidaysComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
